(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hyrley-outdoor-pods"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    let selectedModel = '';
    let selectedSize = '';
    const features = new Set();
    const waButtons = root.querySelectorAll('[data-hp-wa]');
    const update = () => {
      const selected = [selectedModel, selectedSize, ...features].filter(Boolean).join(' · ');
      root.querySelectorAll('[data-hp-size]').forEach(button => {
        const matches = button.dataset.hpSize === selectedSize && (!button.dataset.hpModel || button.dataset.hpModel === selectedModel);
        button.setAttribute('aria-pressed', String(matches));
      });
      const message = root.dataset.waMessage + (selected ? '\nConfiguration: ' + selected : '');
      waButtons.forEach(button => {
        button.href = 'https://wa.me/' + root.dataset.waNumber.replace(/\D/g, '') + '?text=' + encodeURIComponent(message);
      });
    };
    root.querySelectorAll('[data-hp-size]').forEach(button => button.addEventListener('click', () => {
      selectedSize = button.dataset.hpSize;
      if (button.dataset.hpModel) selectedModel = button.dataset.hpModel;
      update();
    }));
    root.querySelectorAll('[data-hp-feature]').forEach(button => button.addEventListener('click', () => {
      const feature = button.dataset.hpFeature;
      if (features.has(feature)) features.delete(feature); else features.add(feature);
      button.setAttribute('aria-pressed', String(features.has(feature)));
      update();
    }));
    function generateEventId() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      return 'wa_' + Date.now() + '_' + Math.random().toString(36).substring(2, 12);
    }
    waButtons.forEach(button => {
      if (button.dataset.trackingInstalled === 'true') return;
      button.dataset.trackingInstalled = 'true';
      button.addEventListener('click', () => {
        if (window.Shopify?.designMode || new URLSearchParams(window.location.search).has('preview_theme_id')) return;
        const eventData = {
          event_id: generateEventId(),
          event_time: Math.floor(Date.now() / 1000),
          contact_method: 'whatsapp',
          event_source: 'outdoor_kitchen_landing_page',
          button_location: button.dataset.buttonLocation || 'contact',
          button_name: 'landing_whatsapp',
          page_id: root.dataset.pageId || '',
          page_title: root.dataset.pageTitle || '',
          landing_page_url: root.dataset.pageUrl || '',
          page_url: window.location.href,
          page_path: window.location.pathname,
          market_country: root.dataset.marketCountry || '',
          language: root.dataset.language || '',
          landing_variant: root.dataset.landingVariant,
          selected_model: selectedModel,
          selected_size: selectedSize,
          selected_features: [...features].join(', ')
        };
        try {
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            window.Shopify.analytics.publish('haixin:whatsapp_click', eventData);
          }
        } catch (error) {
          console.warn('WhatsApp tracking event failed', error);
        }
      });
    });
    update();
  };
  document.querySelectorAll('[data-hp]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hp]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyrley-quote"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-hyrley-quote-page]');
  if (!root) return;
  const configuration = new URLSearchParams(location.search).get('configuration');
  if (configuration) {
    const summary = root.querySelector('[data-hq-configuration]');
    summary.textContent = configuration;
    summary.hidden = false;
  }
  root.querySelector('[data-hq-wa]').href = 'https://wa.me/8613554768901?text=' + encodeURIComponent('Hi, I would like an outdoor kitchen quote.\n' + (configuration || ''));
})();

  } catch(e) { console.error(e); }
})();
})();
